import React, {
  type FC,
  type PropsWithChildren,
  useEffect,
  useState,
} from 'react';

export interface IConfig {
  domain: string;
  clientId: string;
}

export const ConfigContext = React.createContext<IConfig | null>(null);

const ConfigProvider: FC<PropsWithChildren> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState<IConfig | null>(null);
  useEffect(() => {
    async function load(): Promise<void> {
      setLoading(true);
      const f = await fetch('/config.json');
      setConfig((await f.json()) as IConfig);
      setLoading(false);
    }

    void load();
  }, []);
  return loading ? (
    <></>
  ) : (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};

export default ConfigProvider;
